import React, {
  createContext,
  useContext,
  useState,
  useCallback,
  ReactNode,
} from "react";

interface ActiveKeyboardContextType {
  activeKeyboardId: string | null;
  openKeyboard: (id: string) => void;
  closeKeyboard: () => void;
}

const ActiveKeyboardContext = createContext<
  ActiveKeyboardContextType | undefined
>(undefined);

interface ActiveKeyboardProviderProps {
  children: ReactNode;
}

export const ActiveKeyboardProvider: React.FC<ActiveKeyboardProviderProps> = ({
  children,
}) => {
  const [activeKeyboardId, setActiveKeyboardId] = useState<string | null>(
    null,
  );

  const openKeyboard = useCallback((id: string) => {
    setActiveKeyboardId(id);
  }, []);

  const closeKeyboard = useCallback(() => {
    setActiveKeyboardId(null);
  }, []);

  const contextValue: ActiveKeyboardContextType = {
    activeKeyboardId,
    openKeyboard,
    closeKeyboard,
  };

  return (
    <ActiveKeyboardContext.Provider value={contextValue}>
      {children}
    </ActiveKeyboardContext.Provider>
  );
};

export const useActiveKeyboard = (): ActiveKeyboardContextType => {
  const context = useContext(ActiveKeyboardContext);
  if (!context) {
    throw new Error(
      "useActiveKeyboard must be used within an ActiveKeyboardProvider",
    );
  }
  return context;
};
